/** 多用于接口返回 paging 字段的类型标注 */
export interface Paging {
  num_pages: number;
  count: number;
}

/** 用于查询列表参数重的通用分页参数 */
export interface RequestPaging {
  current_page: number;
  page_size: number;
}

/** 媒体服务费信息 */
export const MediaFeeMedium = {
  GOOGLE: 'GOOGLE',
} as const;